import { t } from '@sm/intl';
import COPY from '~app/pages/Pricing/copy';

export type RouteObject = {
  [key: string]: Route;
};

export type Route = {
  path: string;
  title: string;
  packageType: string;
};

const ROUTE_CONFIG: RouteObject = {
  teams: {
    path: '/pricing/teams',
    title: t(COPY.TEAM_PLANS),
    packageType: 'teams',
  },
  individual: {
    path: '/pricing/individual',
    title: t(COPY.INDIVIDUAL_PLANS),
    packageType: 'individual',
  },
  enterprise: {
    path: '/pricing/enterprise',
    title: t(COPY.ENTERPRISE),
    packageType: 'enterprise',
  },
};

export default ROUTE_CONFIG;
